import React from 'react';
import './SurveyModal.scss';
import GeneralModal from '../../Modals/GeneralModal/GeneralModal';
import SurveyComponent from '../../containers/SurveyContainer';

export default class SurveyModal extends React.Component {
  
  // Init
  
  constructor(props) {
    super(props);
    this.state = {
    
    };
  }
  
  // Methods
  
  
  
  // Render
  
  render() {
    const { userId, adminId, company, close, surveyId, addDataQuery, finish, surveyResponseId, surveyResponseDetailId,
      defaultValuesForQuestions, open = false, editable = true, isTestResponse = false, showPreviousButton = true} = this.props;
    
    if(open){
      if(!userId || !adminId || !company || !close || !surveyId || !finish){
        console.log('SurveyModal (render): Missing at least 1 required prop. userId:', userId, 'adminId:', adminId, 'company:', company, 'close:', close, 'surveyId:', surveyId, 'finish:', finish);
      }
    }
    return (
      <GeneralModal width={'800px'}
                    height={'800px'}
                    isOpen={open}
                    maxHeight={1000}
                    isEditing={false}
                    showFooter={false}
                    showHeader={false}
                    noTitleHeading={true}
                    showSaveButton={false}
                    handleCloseModal={close}
                    presentedInsideParentModal={true}>
        <SurveyComponent userId={userId}
                         adminId={adminId}
                         company={company}
                         editable={editable}
                         surveyId={surveyId}
                         onFinish={finish}
                         addDataQuery={addDataQuery ? (aSurveyResponseDetailsId, aSurveyResponseId) => addDataQuery(aSurveyResponseDetailsId, aSurveyResponseId) : null}
                         isTestResponse={isTestResponse}
                         surveyResponseId={surveyResponseId}
                         showPreviousButton={showPreviousButton}
                         surveyResponseDetailId={surveyResponseDetailId}
                         defaultValuesForQuestions={defaultValuesForQuestions}
        />
      </GeneralModal>
    )
  }
}
